/* @flow */

import * as React from 'react';
import styled from 'styled-components';

import FlexBox from '../FlexBox';
import withI18n from '../../utils/withI18n';
import { pencentage, multiply } from '../../utils/number';

const NormalVal = styled.span`
  margin-left:3px;
`;

const DiscountVal = styled.span`
  color: ${({ theme }) => theme.fontColor2};
  text-decoration: line-through;
`;

type ComponentProps = {
  userInfo: Object,
  userAssets: Object,
  i18n: Object,
  userGasRate: number,
};

export default
@withI18n
class FeeDiscount extends React.PureComponent<ComponentProps> {
  static defaultProps = {
    i18n: {},
  }

  render() {
    const {
      userGasRate, i18n, userInfo, userAssets,
    } = this.props;
    const { commissionStatus } = userInfo.userData || {};
    const discount = pencentage(multiply(userGasRate), 1, { digit: 0 });
    return (
      <FlexBox>
      &nbsp;({commissionStatus === 1 && userAssets.BNB > 1 ?
        <NormalVal>{discount} {i18n.discount || 'discount'}</NormalVal>
        : <DiscountVal>{discount} {i18n.discount || 'discount'}</DiscountVal>
      })&nbsp;
      </FlexBox>
    );
  }
}
